import {
  CandidateEmailActionsDocument,
  CandidateEmailActionsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCandidateEmailActions = (
  variables: CandidateEmailActionsQueryVariables,
  skipFetch: { skip: boolean } = { skip: false }
) => {
  const { data, loading } = useQuery(CandidateEmailActionsDocument, {
    variables,
    skip: skipFetch?.skip,
  })
  const nodes = data?.ats.candidateEmailActionsConnection.nodes

  return {
    loading,
    candidateEmailActions: nodes ? nodes : [],
  }
}
